import { motion } from 'framer-motion';

export default function CompanyBio() {
  return (
    <section className="py-24 bg-gradient-to-b from-dark-900 to-dark-800 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'linear-gradient(#00D4FF 1px, transparent 1px), linear-gradient(90deg, #00D4FF 1px, transparent 1px)',
          backgroundSize: '50px 50px'
        }} />
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="lg:col-span-2"
          >
            <div className="relative">
              <i className="ri-double-quotes-l text-8xl text-electric-blue/20 absolute -top-6 -left-4 w-20 h-20 flex items-center justify-center"></i>
              <div className="relative z-10 space-y-6">
                <h2 className="font-orbitron text-4xl font-bold text-white mb-8">
                  OUR{' '}
                  <span className="text-electric-blue">STORY</span>
                </h2>
                <p className="font-inter text-white/80 text-base leading-relaxed">
                  LONE TRS LLC is a family-owned transportation and relocation company built on a foundation of 16 years of industry experience. While our company is brand new, our expertise runs deep.
                </p>
                <p className="font-inter text-white/80 text-base leading-relaxed">
                  Based in the heart of the Las Vegas Valley, we proudly serve the entire region from Henderson to Mesquite and extend our premium services across the entire West Coast.
                </p>
                <p className="font-inter text-white/80 text-base leading-relaxed">
                  Our comprehensive services include residential and commercial relocations, interstate and outstate moves, general freight, building materials transport, and specialized vehicle transport. Every move is handled with the care and precision that only comes from years of dedicated experience.
                </p>
                <div className="pt-8">
                  <div className="inline-block bg-gradient-to-r from-electric-blue/20 to-electric-cyan/20 border border-electric-blue/50 rounded-2xl px-8 py-6">
                    <div className="font-orbitron text-6xl font-bold text-electric-blue mb-2">16+</div>
                    <div className="font-inter text-white/90 text-sm tracking-wider">YEARS OF EXCELLENCE</div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="lg:col-span-3"
          >
            <div className="relative">
              <div className="relative rounded-3xl overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/36d8eb652ef564a74934ccb89edffc18.jpg"
                  alt="LONE TRS Fleet"
                  className="w-full h-[500px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-dark-900/80 via-dark-900/20 to-transparent" />
              </div>
              <div className="absolute top-8 right-8 space-y-4">
                {[
                  { icon: 'ri-home-heart-line', label: 'Family Owned' },
                  { icon: 'ri-map-pin-range-line', label: 'West Coast Coverage' },
                  { icon: 'ri-shield-check-line', label: 'Licensed & Insured' },
                ].map((item, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, x: 20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                    viewport={{ once: true }}
                    className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-xl px-6 py-4 flex items-center space-x-3 hover:bg-white/20 transition-all duration-300"
                  >
                    <i className={`${item.icon} text-2xl text-electric-blue w-8 h-8 flex items-center justify-center`}></i>
                    <span className="font-inter text-white font-medium text-sm whitespace-nowrap">{item.label}</span>
                  </motion.div>
                ))}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
